(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearches = this.querySelectorAll('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.setupScrolledState();
  }

  setHeaderHeight() {
    // The bar's own height, not the section's: on photo-hero pages the
    // section is a zero-height sticky shell around an absolute overlay, so
    // Dawn's section measurement would report 0 and collapse everything
    // that offsets from --header-height (the mobile drawer, for one).
    document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    if (this.onScrolledCheck) window.removeEventListener('scroll', this.onScrolledCheck);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  /*
   * Scrolled state: `.header--scrolled` on the section as soon as the page
   * has scrolled past the bar's own height. The class is what
   * frontend/entrypoints/theme.css keys the translucent-navy treatment off.
   *
   * This used to watch the hero with an IntersectionObserver and flip when
   * the hero's *bottom* passed under the bar. That left a long middle state
   * on every hero page — scrolled past the bar but not yet past the hero —
   * where the bar had no fill at all and the white logo sat on whatever
   * white section had scrolled up behind it. One threshold, both rest
   * states, no gap (2026-09-10 QA regression 1).
   */
  setupScrolledState() {
    // offsetHeight is read per call rather than cached: the bar's height
    // changes with the breakpoint, and setHeaderHeight already re-runs on
    // that media query.
    this.onScrolledCheck = () => {
      this.header.classList.toggle('header--scrolled', window.scrollY > this.offsetHeight);
    };

    window.addEventListener('scroll', this.onScrolledCheck, { passive: true });
    this.onScrolledCheck();
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
    this.searchModals.forEach((searchModal) => searchModal.close(false));
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-map"] && !Shopify.designMode) return;
  try {
    
class ImpactMap extends HTMLElement {
  connectedCallback() {
    this.svg = this.querySelector('svg');
    this.tooltip = this.querySelector('.impact-map__tooltip');
    this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.paths = [...this.svg.querySelectorAll('path')];
    this.onDocumentClick = this.onDocumentClick.bind(this);

    // Hover is bound only where there is a real one (2026-09-16 QA round 6,
    // item 11). A tap on a touch screen fires a synthetic mouseenter before
    // the click, so show() had already set activeIndex by the time the
    // click arrived — the toggle then read the state as open and hid it
    // again, opening and closing the tooltip in the same tap. Leaving click
    // as the only path on touch keeps the desktop toggle (a second click
    // dismisses) without the emulated event stealing the first tap.
    const canHover = window.matchMedia('(hover: hover)').matches;

    this.paths.forEach((path, index) => {
      if (canHover) {
        path.addEventListener('mouseenter', () => this.show(path, index));
        path.addEventListener('mouseleave', () => this.hide());
      }
      path.addEventListener('click', (event) => {
        event.stopPropagation();
        this.activeIndex === index ? this.hide() : this.show(path, index);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick() {
    this.hide();
  }

  show(path, index) {
    const info = this.data[index] || this.data.default;
    this.activeIndex = index;
    this.paths.forEach((p) => p.classList.remove('impact-map__state--active'));
    path.classList.add('impact-map__state--active');

    this.tooltip.innerHTML = info.label;
    this.tooltip.classList.add('impact-map__tooltip--visible');
    this.tooltip.setAttribute('aria-hidden', 'false');

    const svgRect = this.svg.getBoundingClientRect();
    const pathRect = path.getBoundingClientRect();
    this.tooltip.style.left = `${pathRect.left - svgRect.left + pathRect.width / 2}px`;
    this.tooltip.style.top = `${pathRect.top - svgRect.top}px`;
  }

  hide() {
    this.activeIndex = undefined;
    this.paths.forEach((p) => p.classList.remove('impact-map__state--active'));
    this.tooltip.classList.remove('impact-map__tooltip--visible');
    this.tooltip.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('impact-map', ImpactMap);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["library-hero"] && !Shopify.designMode) return;
  try {
    
/*
 * The scrolling is the browser's — scroll-snap on the track handles swipe,
 * trackpad and keyboard-on-the-scroller for free. This only does the two
 * things CSS cannot: move the track when a progress bar is clicked, and
 * report which slide is in view back to the bars.
 *
 * The progress row sits outside the track (one row, not one per slide) so
 * it can never scroll away, which means it cannot inherit the active
 * slide's color scheme the way it would as a child. Copying the computed
 * foreground across is a line of script and keeps the bars legible on
 * whichever scheme the client picks per slide.
 */
class LibraryHero extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.slides = [...this.querySelectorAll('[data-hero-slide]')];
    this.dots = [...this.querySelectorAll('[data-hero-dot]')];
    if (!this.track || this.slides.length === 0) return;

    this.onDotClick = (event) => {
      const index = Number(event.currentTarget.dataset.heroDot);
      this.track.scrollTo({ left: this.slides[index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    };
    this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));

    // A scroll listener would fire hundreds of times per swipe; the
    // observer fires once per slide crossing the halfway mark.
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.setActive(this.slides.indexOf(entry.target));
        });
      },
      { root: this.track, threshold: 0.6 }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));

    this.setActive(0);
  }

  disconnectedCallback() {
    this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    this.observer?.disconnect();
  }

  setActive(index) {
    if (index < 0 || index === this.activeIndex) return;
    this.activeIndex = index;
    this.dataset.active = String(index);

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('library-hero__bar--active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    const progress = this.querySelector('.library-hero__progress');
    if (progress) progress.style.color = getComputedStyle(this.slides[index]).color;
  }
}

customElements.define('library-hero', LibraryHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
/*
 * Only job: the collection sidebar's mobile accordion (build brief, mobile
 * rule 4). Which of the two shapes the sidebar takes — nav column or
 * collapsed accordion — is decided by the media query in theme.css, not
 * here, so this never has to measure the viewport or undo a wrong first
 * paint. It flips one attribute and lets CSS decide whether that attribute
 * means anything at the current width.
 */
class CollectionSidebar extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.collection-sidebar__toggle');
    if (!this.toggle) return;

    this.onToggle = () => {
      const open = this.dataset.open === 'true';
      this.dataset.open = String(!open);
      this.toggle.setAttribute('aria-expanded', String(!open));
    };

    this.dataset.open = 'false';
    this.toggle.addEventListener('click', this.onToggle);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
  }
}

customElements.define('collection-sidebar', CollectionSidebar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/*
 * Two behaviours the product page needs beyond what Dawn already gives it.
 *
 * 1. <product-gallery>. Thumbnails swap the main image locally; the zoom
 *    button opens a <dialog> with the full-size image. Variant switching is
 *    not handled here in any real sense: Dawn's <product-info> refetches
 *    this section for the new variant and publishes `variant-change` with
 *    the parsed HTML, and that HTML already contains the correct image
 *    because the Liquid picked it. So this copies it across rather than
 *    reimplementing "the variant's image, or the product's".
 *
 * 2. The bulk-order link, shown once the quantity input reaches the cap the
 *    max_quantity metafield sets. No metafield, no cap, no link.
 *
 * Escape inside the dialog is deliberately left to bubble. <dialog> closes
 * on it, and SAFE EXIT's document-level double-Escape still sees it — a
 * modal must not be able to disarm the way off this site.
 */
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.main = this.querySelector('[data-gallery-image]');
    this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    this.dialog = this.querySelector('[data-gallery-dialog]');
    this.dialogImage = this.querySelector('[data-gallery-dialog-image]');
    if (!this.main) return;

    this.onThumbClick = (event) => {
      const button = event.currentTarget;
      this.setMain(button.dataset.full, button.dataset.alt);
      this.thumbs.forEach((thumb) => thumb.removeAttribute('aria-current'));
      button.setAttribute('aria-current', 'true');
    };
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', this.onThumbClick));

    const zoom = this.querySelector('[data-gallery-zoom]');
    const close = this.querySelector('[data-gallery-close]');
    this.onZoom = () => {
      if (!this.dialog?.showModal) return;
      this.dialogImage.src = this.main.currentSrc || this.main.src;
      this.dialogImage.alt = this.main.alt;
      this.dialog.showModal();
    };
    this.onClose = () => this.dialog?.close();
    zoom?.addEventListener('click', this.onZoom);
    close?.addEventListener('click', this.onClose);

    // Clicking the backdrop closes it: the dialog element itself fills the
    // viewport, so a click whose target is the dialog rather than its
    // contents landed outside the image.
    this.onDialogClick = (event) => {
      if (event.target === this.dialog) this.dialog.close();
    };
    this.dialog?.addEventListener('click', this.onDialogClick);

    if (typeof subscribe === 'function') {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId !== this.closest('product-info')?.dataset.section) return;
        const incoming = data.html?.querySelector('[data-gallery-image]');
        if (!incoming) return;
        this.setMain(incoming.getAttribute('src'), incoming.getAttribute('alt'), incoming.getAttribute('srcset'));
      });
    }
  }

  disconnectedCallback() {
    this.thumbs?.forEach((thumb) => thumb.removeEventListener('click', this.onThumbClick));
    this.dialog?.removeEventListener('click', this.onDialogClick);
    this.unsubscribe?.();
  }

  setMain(src, alt, srcset) {
    if (!src) return;
    // srcset wins over src in the browser's selection, so a stale one would
    // keep the old image on screen however the src changed.
    if (srcset) this.main.setAttribute('srcset', srcset);
    else this.main.removeAttribute('srcset');
    this.main.setAttribute('src', src);
    if (alt != null) this.main.setAttribute('alt', alt);
  }
}

customElements.define('product-gallery', ProductGallery);

class ProductBulkLink extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('[data-bulk-link]');
    this.input = this.querySelector('.quantity__input');
    if (!this.link || !this.input) return;

    this.sync = () => {
      const max = parseInt(this.input.dataset.max, 10);
      const value = parseInt(this.input.value, 10);
      this.link.hidden = !(max && value >= max);
    };
    this.input.addEventListener('change', this.sync);
    this.input.addEventListener('input', this.sync);
    this.sync();
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this.sync);
    this.input?.removeEventListener('input', this.sync);
  }
}

customElements.define('product-bulk-link', ProductBulkLink);

/* Submit-button label across a variant change.
   Dawn's toggleSubmitButton hardcodes window.variantStrings.addToCart whenever
   it re-enables the button, so a hard copy switched to a PDF kept saying "Add
   to cart" even though the server renders "Get PDF" for a digital variant. The
   re-rendered section already carries the right label, so copy it across rather
   than re-deriving which variants are digital on the client.

   variantChange fires after Dawn has finished its own updates, so this lands
   last and wins. Also re-syncs the quantity row's visibility, which the same
   `unless is_digital` decides server-side. */
if (typeof subscribe === 'function') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    if (!data?.html || !data.sectionId) return;
    const info = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
    if (!info) return;

    const incomingLabel = data.html
      .getElementById(`ProductSubmitButton-${data.sectionId}`)
      ?.querySelector('span');
    const currentLabel = info.querySelector(`#ProductSubmitButton-${data.sectionId} span`);
    if (incomingLabel && currentLabel) currentLabel.textContent = incomingLabel.textContent.trim();

    const incomingRow = data.html.querySelector('.product-main__row');
    const currentRow = info.querySelector('.product-main__row');
    if (currentRow) currentRow.hidden = !incomingRow;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-exit"]) return;
  try {
    
/*
 * SAFE EXIT.
 *
 * Two jobs: leave the site, and get out of the way. Leaving is a click or
 * two Escape presses inside a second, either of which calls
 * location.replace() so the page that was open does not come back from the
 * Back button. Getting out of the way is the collapse: the control renders
 * expanded with its explainer on every page load and shrinks to label and
 * icon the first time the page scrolls.
 *
 * Nothing about the collapsed state is persisted. sessionStorage or a
 * cookie would save a visitor from reading the same line twice, at the cost
 * of leaving a trace on a device that may be monitored, and of skipping the
 * explainer for someone who lands on a deep page from a printed card. The
 * expanded state is cheap; the trace is not (2026-09-10 QA round 4, item 8).
 */
class SafeExit extends HTMLElement {
  connectedCallback() {
    this.exitUrl = this.dataset.exitUrl || 'https://www.google.com';
    this.lastEscape = 0;

    this.onKeydown = this.onKeydown.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onScroll = this.onScroll.bind(this);

    document.addEventListener('keydown', this.onKeydown);
    this.addEventListener('click', this.onClick);
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('click', this.onClick);
    window.removeEventListener('scroll', this.onScroll);
  }

  exit() {
    // replace() keeps this page out of the back button's history. It does
    // not clear anything already in it — see the copy note in index.liquid.
    window.location.replace(this.exitUrl);
  }

  onClick(event) {
    event.preventDefault();
    this.exit();
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;

    const now = Date.now();
    if (now - this.lastEscape < 1000) {
      this.exit();
    } else {
      this.lastEscape = now;
    }
  }

  // Any distance, once. Scrolling back up does not bring it back: the
  // explainer has been read by then, and a control that reappeared under
  // the thumb on every upward scroll would be its own problem.
  onScroll() {
    this.dataset.collapsed = '';
    window.removeEventListener('scroll', this.onScroll);
  }
}

customElements.define('safe-exit', SafeExit);

  } catch(e) { console.error(e); }
})();
})();
